import { useMutation } from '@tanstack/react-query';
import * as _a from '@/lib/api';

export const useMoviePlays = () => {
  const mutation = useMutation({
    mutationFn: _a.moviePlays,
  });
  return { mutation };
};
